import React from "react";

function NotFound() {
  const frontEndHost = window.location.hostname;

  return (
    <>
      <section className="page_404_NotFound">
        <div className="container-a">
          <div className="row">
            <div className="col-sm-12 ">
              <div className="col-sm-10 col-sm-offset-1  text-center">
                <div className="four_zero_four_bg">
                  <h1 className="text-center">404</h1>
                </div>
                <div className="contant_box_404">
                  <h3 className="h2">Look like you're lost</h3>
                  <p>
                    We searched everyware but unable to find what you are
                    looking
                  </p>

                  <a
                    href={
                      frontEndHost === "127.0.0.1" ||
                      frontEndHost === "localhost" ||
                      frontEndHost === "aryabhattadev.quloi.com"
                        ? "https://jdadmindev.quloi.com/"
                        : "https://jdadmin.quloi.com/"
                    }
                    className="link_404"
                  >
                    Go to Home
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NotFound;
